import { useSelector } from 'react-redux';
import {
    extractPrivileges,
    isValidToken,
    isInternalUser,
} from '../utils/authentication';
import { getAccessToken } from '../reducers';

function useAuthentication() {
    const accessToken = useSelector(getAccessToken);
    const isUserLoggedIn = isValidToken(accessToken);
    const userPrivileges = extractPrivileges(accessToken);
    return {
        accessToken,
        isUserLoggedIn,
        userPrivileges,
        isInternalUser: isInternalUser(accessToken),
    };
}

export default useAuthentication;
